function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import validator from "./validator";
import { t } from "../translator";
import object from "../utils/object";
/**
 * class "Mapping" permet la récupération des asserts
 * et des règles établies sur les attributs d'une entités
 */

var Mapping = /*#__PURE__*/function () {
  /**
   * @param {?object} definition
   * @param {?object} validator
   */
  function Mapping() {
    var definition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _validator = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, Mapping);

    this.definition = definition;
    this.validator = _validator;
  }
  /**
   * Récupère les règles de validation pour faire la définition du mapping.
   *
   * @return {object}
   */


  _createClass(Mapping, [{
    key: "rules",
    get: function get() {
      if (!this.validator) {
        this.validator = validator.build(this.definition);
      }

      return this.validator;
    }
    /**
     * Récupère les valeurs par défaut basé sur le mapping
     *
     * @param {object} properties
     *
     * @return {object}
     */

  }, {
    key: "getDefaultValues",
    value: function getDefaultValues() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.definition;
      var obj = {}; // eslint-disable-next-line guard-for-in

      for (var prop in properties) {
        var definition = properties[prop];

        if (definition.default !== null) {
          obj[prop] = Array.isArray(definition.properties) && definition.properties.length > 0 ? this.getDefaultValues(definition.properties) : definition.default;
        }
      }

      return object.clone(obj, {});
    }
    /**
     * Trouve la configuration du mapping pour un chemin de propriété
     *
     * @param {string} path
     *
     * @return {object}
     */

  }, {
    key: "find",
    value: function find(propertyPath) {
      var pathData = propertyPath.split('.');
      var mapping = this.definition;
      var prop = ''; // Browse path

      for (var i = 0, len = pathData.length; i < len; ++i) {
        prop = pathData[i]; // Remove array notation like addresses[0] to addresses
        // to get correct property name

        var arrayNotationIndex = prop.indexOf('[');

        if (arrayNotationIndex !== -1) {
          prop = prop.substring(0, arrayNotationIndex);
        } // No mapping found for defined propertyPath


        if (mapping === undefined || !mapping.hasOwnProperty(prop)) {
          mapping = undefined;
          break;
        }

        mapping = mapping[prop]; // Nested property with "."

        if (i < len - 1) {
          mapping = mapping.properties;
        }
      }

      return mapping;
    }
    /**
     * Vérifie si le chemin existe dans le mapping.
     *
     * @param {string} path
     *
     * @return {boolean}
     */

  }, {
    key: "has",
    value: function has(path) {
      return this.find(path) !== undefined;
    }
    /**
     * Obtien les contraintes du chemin contenu dans le mapping. (si existant)
     *
     * @param {string} path
     *
     * @return {null|array}
     */

  }, {
    key: "getConstraints",
    value: function getConstraints(path) {
      var mapping = this.find(path);

      if (!mapping || !mapping.constraints) {
        return null;
      }

      return mapping.constraints;
    }
    /**
     * Permet d'obtenir une contraintes choisit (via alias)
     * d'un chemin contenu dans le mapping
     *
     * @param {string} path  - Chemin de la propriété
     * @param {string} alias - Alias de la contrainte
     *
     * @return {null|object}
     */

  }, {
    key: "getConstraint",
    value: function getConstraint(path, alias) {
      var constraints = this.getConstraints(path);

      if (constraints) {
        for (var i = 0, len = constraints.length; i < len; ++i) {
          if (constraints[i].alias === alias) {
            return constraints[i];
          }
        }
      }

      return null;
    }
    /**
     * Extrait pour une contraines de type Choix les options pour
     * le chemin passé en paramètre. (si existant)
     *
     * @param {string} path
     *
     * @return {array}
     */

  }, {
    key: "getChoices",
    value: function getChoices(path) {
      var constraint = this.getConstraint(path, 'Choice');

      if (constraint && constraint.choices) {
        if (Array.isArray(constraint.choices)) {
          return constraint.choices.map(function (value) {
            return {
              label: t(value),
              value: value
            };
          });
        }

        if (_typeof(constraint.choices) === 'object') {
          return Object.keys(constraint.choices).map(function (key) {
            return {
              label: t(key),
              value: constraint.choices[key]
            };
          });
        }
      }

      return [];
    }
    /**
     * Test si la propriété contient "NotNull" ou la propriété "min" dans ses contraintes
     *
     * @param {string} path
     *
     * @return {boolean}
     */

  }, {
    key: "isRequired",
    value: function isRequired(path) {
      var constraints = this.getConstraints(path);

      if (constraints) {
        for (var i = 0, len = constraints.length; i < len; ++i) {
          if (constraints[i].alias === 'NotNull' || constraints[i].min >= 1) {
            return true;
          }
        }
      }

      return false;
    }
    /**
     * Obtient un point d'entrée pour répertorier
     * les éléments d'une propriété imbriquée
     *
     * @param {string} path - chemin de la Propriété voulu
     *
     * @return {?string}
     */

  }, {
    key: "getEntrypoint",
    value: function getEntrypoint(path) {
      var config = this.find(path);
      return config && config.context;
    }
  }]);

  return Mapping;
}();

export { Mapping as default };